export default __webpack_public_path__ + "static/media/amazon__logo.5b90f1aa.png";